import { AbstractControl } from '@angular/forms';

export function faxNumberValidator(control: AbstractControl) {
  const FAX_NUMBER_REGEX = /^\d{3}-\d{3}-\d{4}$/;
  const value = control.value?.trim();

  return FAX_NUMBER_REGEX.test(value) ? null : { faxNumber: true };
}
